<template>
    <div id="app">
        <router-view/>

        <!--完善用户信息-->
        <ImproveProfile/>
    </div>
</template>

<script>
    import store from "../src/vuex/store";
    import ImproveProfile from "./components/_widget/ImproveProfile.vue";
    export default {
        name: "app",
        data(){
            return {
                done:false
            }
        },
        watch: {
            $route(v) {
                this.loadProfile(false);
            }
        },
        created(){
            this.loadShake();


            //cart

            this.$event_bus.$on("woaCartLoad", () => {
                this.loadCart('woa');
            });
            this.$event_bus.$on("weiboCartLoad", () => {
                this.loadCart('weibo');
            });
            this.$event_bus.$on("liveCartLoad", () => {
                this.loadCart('live');
            });

            this.$event_bus.$on("newsCartLoad", () => {
                this.loadCart('news');
            });

            this.$event_bus.$on("videoCartLoad", () => {
                this.loadCart('video');
            });

            this.$event_bus.$on("xhsCartLoad", () => {
                this.loadCart('xhs');
            });

            //首次加载购物车
            this.loadCart(this.$store.state.cartTaxonomy)
        },
        store,
        methods: {
            loadProfile(loading) {
                let loadingInstance = loading && this.$loading();

                this.$http
                    .get("/personal/profile")
                    .then(response => {

                        this.$store.commit("changeAuth", {
                            isLogin: !!response.success,
                            isDone:true
                        });

                        this.$store.commit("changeProfile", response.success ? response.data : this.$store.state._profile);

                        this.done = response.success

                        /*if(response.success && process.env.NODE_ENV === 'production')
                        {
                            //判断agency.site
                            if(response.data.agency.site)
                            {
                                if(response.data.agency.site!=window.location.host)
                                {
                                    window.location.href='http://'+response.data.agency.site
                                }
                            }
                        }*/
                    })
                    .catch(res => {
                    })
                    .then(response => {
                        this.$nextTick(() => {
                            loading && loadingInstance.close();
                        });
                    });
            },
            //检测用户在线状态
            loadShake()
            {
                this.$http
                    .get("/auth/shake?t="+(+new Date))
                    .then(response => {
                    }).catch().then(()=>{
                        setTimeout(()=>{
                            this.loadShake()
                        },30000)
                    })
            },
            loadCart(taxonomy) {

                this.$store.commit('changeCartLoading',true)

                this.$http
                    .get(`/cart?taxonomy=${taxonomy}`)
                    .then(response => {
                        if (response.success) {

                            this.$store.commit('changeCartSource',{taxonomy:taxonomy,dataSource:response.data})
                            // this.dataSource = response.data;

                            // this.length[this._taxonomy] = this.dataSource.length;

                            // this.money = 0;
                            // this.dataSource.forEach(element => {
                            //     this.money += parseInt(element.price);
                            // });
                            // this.money = this.money.toFixed(2);
                        }
                    })
                    .catch()
                    .then(() => {
                        this.$store.commit('changeCartLoading',false)
                    });
            },
        },
        components: {
            ImproveProfile
        }
    };

</script>



// WEBPACK FOOTER //
// src/App.vue